import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHelpCircle } = FiIcons;

const EntrySituations = () => {
  const situations = [
    "„Wir haben viele Tools, aber nichts greift wirklich ineinander.“",
    "„Wir wollen KI einsetzen, wissen aber nicht, wo wir anfangen sollen.“",
    "„Unsere Prozesse sind historisch gewachsen und völlig unklar.“",
    "„Automatisierungsversuche scheitern bei uns immer wieder.“"
  ];

  return (
    <section className="py-24 bg-azure-600 text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold mb-12 text-center">Erkennen Sie sich hier wieder?</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {situations.map((text, i) => (
              <div key={i} className="bg-white/10 backdrop-blur-sm p-6 rounded-xl flex items-start">
                <SafeIcon icon={FiHelpCircle} className="text-azure-200 mt-1 mr-4 flex-shrink-0" />
                <p className="text-lg italic font-medium">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EntrySituations;